import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { browserHistory } from 'react-router';
import * as Sentry from '@sentry/react';
import './fetch';
import './styles';
import Dashboard from './scenes/Dashboard';
import PageNotFound from './scenes/notfound';
import FallBackErrorComponent from './FallBackErrorComponent';
import { Container, ThemeProvider } from '@material-ui/core';
import { theme } from './theming';
import { createTheme } from '@material-ui/core/styles';
import { RecoilRoot } from 'recoil';
import InterventionOrder from './scenes/InterventionOrder';
import NotificationCenter, {
  NotificationCenterProvider,
} from 'src/components/NotificationCenter/AlertNotificationCenter';
import PublicRouter from './scenes/public/PublicRouter';
import { AuthProvider } from './hooks/api/useAuth';
import Login from './scenes/Login';
import { API_BASE_URL, APP_DEPLOY_ENV, APP_VERSION, SENTRY_DSN } from 'src/env';
import { CookiesProvider } from 'react-cookie';

if (APP_DEPLOY_ENV !== 'dev') {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: APP_VERSION,
    environment: APP_DEPLOY_ENV,
    ignoreErrors: ['Authentification requise.', 'ResizeObserver loop limit exceeded', 'Failed to fetch'],
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        tracePropagationTargets: [API_BASE_URL],
      }),
    ],
    tracesSampleRate: 0.2,
    maxBreadcrumbs: 100,
  });
}

const muiTheme = createTheme(theme);

const App: React.FC = () => {
  return (
    <Router history={browserHistory}>
      <Sentry.ErrorBoundary fallback={FallBackErrorComponent} showDialog>
        <CookiesProvider>
          <ThemeProvider theme={muiTheme}>
            <RecoilRoot>
              <div className='app-theme-light'>
                <NotificationCenterProvider>
                  <AuthProvider>
                    <Switch>
                      <Route exact path='/' render={(props) => <Login {...props} />} />
                      <Route path='/dashboard' render={(props) => <Dashboard {...props} />} />
                      <Route path='/intervention-orders/new' render={(props) => <InterventionOrder {...props} />} />
                      <PublicRouter />
                      <Route path='/*' render={(props) => <PageNotFound {...props} />} />
                    </Switch>

                    <Container maxWidth='md'>
                      <NotificationCenter
                        style={{
                          position: 'fixed',
                          right: '2rem',
                          bottom: '2rem',
                        }}
                      />
                    </Container>
                  </AuthProvider>
                </NotificationCenterProvider>
              </div>
            </RecoilRoot>
          </ThemeProvider>
        </CookiesProvider>
      </Sentry.ErrorBoundary>
    </Router>
  );
};

export default App;
